import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as ActionsServices from '../../redux/modules/services';
import * as ActionsText from '../../redux/modules/text';
import ListEntity from '../../components/ListEntity/List';
import Service from '../../components/ListEntity/Entities/Service';
import Modal from '../../components/Render/Modal/Modal';
import ServiceForm from '../../forms/service-form/ServiceForm';
import GenericTextForm from '../../forms/generic-text/index';
import LayoutSection from '../../components/layout-section';
import TextSection from '../../components/ListEntity/TextSection';

class General extends PureComponent {
  state = {isOpenNews: false, isOpenArticles: false};

  getData() {
    this.props.getAction();
    this.props.getTextAction('services');
  }

  componentWillMount() {
    this.getData()
  }

  remove(info) {
    if (info.id > 0) {
      const {getAction, delAction} = this.props;
      delAction(info.id).then(() => {
        getAction();
      });
    }
  }

  toggleOpenModal(form = "services", data = {}) {
    this.setState({isOpen: !this.state.isOpen, form, data});
  }

  render() {
    const {services, text} = this.props;
    return (
      <div className="contacts-container container">

        <LayoutSection
          isFetching={text.isFetching}
          title="Services">
          <TextSection
            editAction={() => {
              this.toggleOpenModal('text', text.values);
            }}>
            <div dangerouslySetInnerHTML={{__html: text.values.body}}></div>
          </TextSection>
        </LayoutSection>

        <LayoutSection
          isFetching={services.isFetching}
          title="">
          <ListEntity
            number={3}
            component={Service}
            removeAction={(index) => {
              this.remove(services.values[index])
            }}
            editAction={(index) => {
              this.toggleOpenModal(null, services.values[index]);
            }}
            addAction={() => {
              this.toggleOpenModal(null);
            }}
            values={services.values}/>
        </LayoutSection>

        <div className="contacts-container__modal">
          <Modal
            toogle={this.toggleOpenModal.bind(this)}
            isOpen={this.state.isOpen}>
            {
              this.state.form === 'text' ?
                <GenericTextForm
                  numberOfImages={0}
                  section="services"
                  close={this.toggleOpenModal.bind(this)}
                  defaultValues={this.state.data}/>
                :
                <ServiceForm
                  defaultValues={this.state.data}
                  close={this.toggleOpenModal.bind(this)}/>
            }
          </Modal>
        </div>
      </div>
    );
  }
}

General.propTypes = {};
General.defaultProps = {};

export default connect(
  (state) => {
    return {
      services: state.services,
      text: state.text,
    };
  },
  (dispatch) => {
    return bindActionCreators(
      {
        getAction: ActionsServices.get,
        delAction: ActionsServices.del,
        getTextAction: ActionsText.get
      }, dispatch);
  }
)(General);



// WEBPACK FOOTER //
// ./src/containers/services/Services.js